"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.zIndex = void 0;
// For CDS internal use only
const zIndex = {
  interactable: 1,
  navigation: 2,
  overlays: {
    portal: 100001,
    popoverMenu: 2,
    modal: 3,
    dropdown: 4,
    tooltip: 5,
    toast: 6,
    alert: 7
  },
  max: 2147483647
};
exports.zIndex = zIndex;